import type { RouteObject } from 'react-router';
import { DashboardPage } from './DashboardPage';

export const routes: RouteObject[] = [{ path: '/', element: <DashboardPage /> }];
